import i18n from '@/i18n';
import Vue from 'vue';
import {EventBus} from '@/event-bus.js';
import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import moment from 'moment';

function initialState () {
  return {
    app: {
      layout: null,
      is_rtl: false,
      colors: null,
      isAppLoading: false,
    },
    // in reference of multiple screening urls
    currentFilmIndex: 0,
    preRollEnded: false,
    i18n_locale: i18n.locale,
    // in reference to player time
    currentTime: null,
    currentScreenerId: null,
    isEmbedMode: false,
    darkMode : false,
    fontFamily: DEFINES.DEFAULT_FONTS,
    referrerURL: null,
    // referrerURL: 'http://localhost:3000'
  };
}

const state = initialState ();

// actions

const actions = {
  showMessage: (context, payload) => {
    EventBus.$emit ('showMessage', payload);
  },

  showAlert: (context, payload) => {
    EventBus.$emit ('showAlert', payload);
  },

  hideAlert: context => {
    EventBus.$emit ('hideAlert');
  },

  hideMessage: context => {
    EventBus.$emit ('hideMessage');
  },

  setAppLayout (context, payload) {
    context.commit ('set_app_layout', payload);
  },

  showLoader (context) {
    EventBus.$emit ('showLoader');
    context.commit ('set_app_loader', true);
  },

  hideLoader (context) {
    EventBus.$emit ('hideLoader');
    context.commit ('set_app_loader', false);
  },

  updateLocale (context, payload) {
    context.commit ('set_locale', payload);
  },

  setTheme (context, payload) {
    let existingLocale = context.state.i18n_locale
      ?context.state.i18n_locale
      :payload.company.custom_properties.language

    context.commit ('set_locale', {
      locale: existingLocale,
    });
    context.commit ('set_rtl', {
      rtl: payload.company.custom_properties.is_rtl,
    });
    context.commit ('set_colors', payload.company.custom_properties.theme);
    context.commit ('set_dark_mode', payload.company.custom_properties);
    context.commit ('set_font_family', payload.company.custom_properties);
  },

  showSupportNotification: (context, payload) => {
    EventBus.$emit ('showSupportNotification', payload);
  },
  enableEmbedMode: (context, payload) => {
    context.commit ('enable_embed', {
      isEmbed: payload.isEmbed
    });
  },

  resetTheme (context, payload) {
    context.commit ('set_locale', {
      locale: DEFINES.THEME.PLATFORM.LOCALE,
    });
    context.commit ('set_rtl', {
      rtl: DEFINES.THEME.PLATFORM.RTL,
    });
    context.commit ('set_colors', {});
  },

  setReferrerUrl (context, payload) {
    context.commit ('set_referrer_url', payload.referrer);

  }
};

// getters
const getters = {
  getField,
  isLoggedIn: (state, getters, rootState) => {
    return (
      rootState.auth.session_mode == DEFINES.SESSION_MODE_CONSUMER &&
      rootState.auth.key &&
      rootState.auth.secret
    );
  },
  getAuthScreener: (state, getters, rootState) => {
    return rootState.auth.screener;
  },
  appLayout: state => state.app.layout,
  isEmbedMode: state => state.isEmbedMode,
  darkMode: state => state.darkMode,
  fontFamily: state => state.fontFamily,
  getCurrentLanguage: state => state.i18n_locale,
  // isNetfestVod is true when user is redirected from netfest vod company to given company id
  isNetfestVod: (state, getters, rootState) => {
    const DEFINES = require("@/defines").default;
    
    const referrerUrl = state.referrerURL || ""; // from app module
    const company = (rootState.company && rootState.company.company) || {}; // from company module
  
    return (
      referrerUrl.includes(DEFINES.NETFEST_VOD_DOMAIN) &&
      company.id === DEFINES.NETFEST_VOD_COMPANY_ID
    );
  }  
};

// mutations
const mutations = {
  updateField,
  set_referrer_url (state, payload) {
    state.referrerURL = payload;
  },
  set_app_layout (state, payload) {
    // console.log ('old layout:', state.app.layout);
    state.app.layout = payload.layout;
    // console.log ('new layout:', state.app.layout);
  },

  set_locale (state, payload) {
    // Change global locale (app's locale)
    i18n.locale = payload.locale;
    // Change locale for the company
    state.i18n_locale = payload.locale;
    // Setting locale for date also.
    moment.locale (i18n.locale);
  },

  set_rtl (state, payload) {
    state.app.is_rtl = payload.rtl;
    Vue.prototype.$vuetify.rtl = payload.rtl;
  },

  set_dark_mode(state, payload){
    if (payload.hasOwnProperty("darkMode")) {
      state.darkMode = payload.darkMode;
    }
  },

  set_font_family(state, payload){
    if (payload.hasOwnProperty("fontFamily")) {
      state.fontFamily = payload.fontFamily;
    }
  },
  set_colors (state, payload) {
    // Default colors
    let DEFAULT = DEFINES.THEME.PLATFORM.COLORS;
    let colors = {
      primaryColor: payload.primaryColor || DEFAULT.PRIMARY,
      secondaryColor: payload.secondaryColor || DEFAULT.SECONDARY,
      backgroundColor: payload.backgroundColor || DEFAULT.BACKGROUND,
    };
    // setting colors in global state
    state.app.colors = colors;
    // Setting in vuetify
    Vue.prototype.$vuetify.theme.primary = colors.primaryColor;
    Vue.prototype.$vuetify.theme.secondary =colors.secondaryColor;
    Vue.prototype.$vuetify.theme.background = colors.backgroundColor;
  },
  enable_embed (state, payload) {
    state.isEmbedMode = payload.isEmbed
  },
  set_app_loader (state, payload) {
    state.app.isAppLoading = payload;
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
  resetPlayerConifg (state) {
    const s = initialState ();
    let resetVar = [ "currentFilmIndex","preRollEnded","currentTime","currentScreenerId"]
    Object.keys (s).forEach (key => {
      if(resetVar.includes(key)){
        state[key] = s[key];
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
